import { render } from "./ServiceOptions.vue?vue&type=template&id=27e01a9a&scoped=true"
import script from "./ServiceOptions.vue?vue&type=script&lang=js"
export * from "./ServiceOptions.vue?vue&type=script&lang=js"

import "./ServiceOptions.vue?vue&type=style&index=0&id=27e01a9a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e01a9a"]])

export default __exports__